var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('nav',[_c('TopNavBar')],1),_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1),_c('Footer'),(!_vm.cookie)?_c('CookieBadge'):_vm._e(),_c('Modal')],1)}
var staticRenderFns = []

export { render, staticRenderFns }